import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface UIState {
  bottomNavigationHeight: number;
}

const initialState: UIState = {
  bottomNavigationHeight: 64, // Default height in pixels
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setBottomNavigationHeight: (state, action: PayloadAction<number>) => {
      state.bottomNavigationHeight = action.payload;
    },
  },
});

export const { setBottomNavigationHeight } = uiSlice.actions;
export default uiSlice.reducer;
